import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    width="160"
    height="163"
    viewBox="0 0 160 163"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M121.999 53.6166C123.546 53.6166 124.799 52.363 124.799 50.8166C124.799 49.2702 123.546 48.0166 121.999 48.0166C120.453 48.0166 119.199 49.2702 119.199 50.8166C119.199 52.363 120.453 53.6166 121.999 53.6166Z"
      fill="#F1F3FA"
    />
    <path
      d="M108.143 73.0097L103.972 103.303L99.0686 138.514C98.8736 139.914 98.0655 141.224 96.7144 141.64C96.0761 141.836 95.4195 141.952 94.7629 141.952H34.6402C32.0338 141.952 29.7748 141.082 27.8634 139.689C27.3421 139.341 26.8208 138.819 26.2995 138.296C24.2143 136.207 22.8242 133.073 22.8242 129.766V65.0013C22.8242 62.0416 25.2569 59.7783 28.0372 59.7783H46.2825C47.4988 59.7783 48.7152 60.3006 49.7578 61.3452L55.6658 67.7868C56.5346 68.6573 57.751 69.1796 58.9673 69.1796H104.667C106.753 69.1796 108.317 70.9206 108.143 73.0097Z"
      fill="url(#paint0_linear_21403_45575)"
    />
    <path
      d="M31.6855 135.337L36.551 79.1033C36.7247 77.0141 38.4624 75.4473 40.5476 75.4473H109.706C111.617 75.4473 113.008 77.0141 112.834 78.9292L107.968 126.806L31.6855 135.337Z"
      fill="white"
    />
    <path
      d="M59.3697 129.217L34 135.136L49.6388 92.1342C50.3339 90.2192 52.0716 89.0005 54.1567 89.0005H115.496C117.755 89.0005 119.319 91.4379 118.276 93.527L101.595 127.65L59.3697 129.217Z"
      fill="#C7BCE4"
    />
    <path
      d="M124.129 107.481L100.845 138.819C100.323 139.515 99.4544 140.211 98.7594 140.734C97.543 141.43 96.1529 141.952 94.7628 141.952H34.6401C33.8375 141.952 33.0678 141.87 32.331 141.715C29.7238 141.167 29.3461 137.959 31.0802 135.936L50.8234 112.906C51.691 111.894 52.9576 111.311 54.2907 111.311H90.4186C92.1563 111.311 93.8939 110.789 95.2841 109.57L101.887 104.521C102.582 103.999 103.277 103.651 103.972 103.303C104.841 102.954 105.884 102.78 106.753 102.78H121.696C124.129 102.606 125.519 105.566 124.129 107.481Z"
      fill="url(#paint1_linear_21403_45575)"
    />
    <path
      d="M111.178 66.058L83.9012 48.3898C82.3329 47.3639 81.8754 45.2783 82.8961 43.6926L99.8348 17.6128C100.863 16.0449 102.95 15.5861 104.537 16.6047L131.814 34.2729C133.382 35.2988 133.84 37.3844 132.819 38.9701L115.888 65.0678C114.86 66.6357 112.747 67.0839 111.178 66.058Z"
      fill="#F5F6FA"
      stroke="#E2E3E8"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M112.206 61.175L88.224 45.6397C87.5463 45.2082 87.3635 44.3031 87.7958 43.6255L101.803 22.0617C102.236 21.3842 103.142 21.2008 103.819 21.6322L127.801 37.1675C128.479 37.599 128.662 38.5042 128.23 39.1817L114.222 60.7455C113.79 61.423 112.884 61.6064 112.206 61.175Z"
      fill="white"
    />
    <path d="M105.997 45.555L97.2438 39.8813L104.828 37.7553L105.997 45.555Z" fill="#C7BCE4" />
    <path d="M113.239 50.2417L100.628 42.0815L111.548 39.0273L113.239 50.2417Z" fill="#C7BCE4" />
    <path
      d="M104.185 34.3488C104.597 35.3548 105.747 35.8359 106.754 35.4234C107.761 35.011 108.244 33.8611 107.832 32.8552C107.42 31.8492 106.27 31.3681 105.262 31.7805C104.255 32.193 103.773 33.3428 104.185 34.3488Z"
      fill="#C7BCE4"
    />
    <path
      d="M68.0931 44.6908L47.7824 49.4052C46.6099 49.6718 45.4435 48.9534 45.1666 47.7756L40.6796 28.3351C40.4142 27.1619 41.1328 25.994 42.3099 25.7159L62.6206 21.0015C63.7931 20.7349 64.9595 21.4532 65.2364 22.631L69.7349 42.0761C70.0003 43.2493 69.2655 44.4242 68.0931 44.6908Z"
      fill="#F5F6FA"
      stroke="#E2E3E8"
      strokeWidth="1.28315"
      strokeMiterlimit="10"
    />
    <path
      d="M66.2991 42.0405L48.4413 46.1848C47.9401 46.3053 47.4409 45.9862 47.3209 45.4847L43.6117 29.4097C43.4917 28.9082 43.8109 28.4083 44.3121 28.2878L62.1699 24.1436C62.671 24.0231 63.1703 24.3421 63.2903 24.8436L66.9994 40.9186C67.1194 41.4201 66.8002 41.92 66.2991 42.0405Z"
      fill="white"
    />
    <path d="M56.3234 37.9449L49.8037 39.4561L52.2026 35.0084L56.3234 37.9449Z" fill="#C7BCE4" />
    <path d="M61.7131 36.6909L52.3268 38.8742L55.784 32.4733L61.7131 36.6909Z" fill="#C7BCE4" />
    <path
      d="M50.3425 33.7871C50.9903 34.0453 51.7251 33.7288 51.9836 33.0801C52.2421 32.4315 51.9264 31.6964 51.2786 31.4382C50.6307 31.18 49.8959 31.4965 49.6374 32.1451C49.3789 32.7937 49.6946 33.5289 50.3425 33.7871Z"
      fill="#C7BCE4"
    />
    <ellipse
      cx="72.4961"
      cy="155.85"
      rx="47.4961"
      ry="6.85039"
      fill="url(#paint2_radial_21403_45575)"
      fillOpacity="0.8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_21403_45575"
        x1="103.631"
        y1="59.7783"
        x2="29.2465"
        y2="144.745"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7876C1" />
        <stop offset="1" stopColor="#C7BCE4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_21403_45575"
        x1="119.547"
        y1="102.773"
        x2="96.3599"
        y2="165.802"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7876C1" />
        <stop offset="1" stopColor="#C7BCE4" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_21403_45575"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(72.4961 155.85) rotate(90) scale(6.85039 47.4961)">
        <stop stopColor="#C7BCE4" />
        <stop offset="1" stopColor="#C7BCE4" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

const EmptyFolderIcon = (props) => <Icon component={svg} {...props} />;

export default EmptyFolderIcon;
